import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { OrderBy } from '@atlassian/jira-servicedesk-knowledge-services';
import type { CategoryGuid } from '@atlassian/jira-servicedesk-knowledge-services/src/types';

export const REMOVE_ARTICLE_FROM_CATEGORY =
	'state.actions.remove-article-from-category.REMOVE_ARTICLE_FROM_CATEGORY' as const;

export type RemoveArticleFromCategoryPayload = {
	categoryId: CategoryGuid;
	articleId: string;
	orderBy?: OrderBy;
	isFeatured?: boolean;
	page?: number;
	pageItemIndex?: number;
	currentCursor?: string;
	previousPagePath?: string;
	noOfPageItems?: number;
	analyticsEvent?: UIAnalyticsEvent;
	spaceKey: string;
};

export type RemoveArticleFromCategoryAction = {
	type: typeof REMOVE_ARTICLE_FROM_CATEGORY;
	payload: RemoveArticleFromCategoryPayload;
};

export const removeArticleFromCategory = (
	payload: RemoveArticleFromCategoryPayload,
): RemoveArticleFromCategoryAction => ({
	payload,
	type: REMOVE_ARTICLE_FROM_CATEGORY,
});
